import React, {useCallback, useState, useEffect} from 'react';
import {useNavigate} from 'react-router-dom';

import "../CSS/Start_page_new.css";
import "../CSS/Start_page_new_mobile.css";
import "../CSS/Profile_new.css";
import "../CSS/Profile_new_mobile.css";
import '../languages/i18n';
import 'react-toastify/dist/ReactToastify.css';

import ReferralBlock from "./Profile_blocks/Referral_block";
import ShopBlock from "./Profile_blocks/Shop_block";
import SubscriptionCancelledBlock from "./Profile_blocks/Subscription_cancelled_block";
import SubscriptionActiveBlock from "./Profile_blocks/Subscription_active_block";
import DevicesBlock from "./Profile_blocks/Devices_block";
import AppDownloadBlock from "./Profile_blocks/App_download_block";
import SupportBlock from "./Profile_blocks/Support_block";
import UserInfoBlock from "./Profile_blocks/User_info_block";

function Profile_new() {
    const navigate = useNavigate();

    const [userData, setUserData] = useState({
        id: 0,
        email: '',
        expirationDate: '',
        subscriptionIsActive: false,
        discount: 0,
        nextTransactionDate: '',
        amount: 0,
        currency: '',
        subscriptionStatus: ''
    });
    const [userSubscription, setUserSubscription] = useState("");
    const [deviceData, setDeviceData] = useState([]);
    const [availableDevices, setAvailableDevices] = useState(0);
    const [shopData, setShopData] = useState([]);

    useEffect(() => {
        const requestData = {
            uid: localStorage.getItem('uid'),
            email: localStorage.getItem('email'),
        };
        fetchLoginData(requestData);
    }, []);

    const fetchShopData =  useCallback((userData) => {

        fetch(`https://gostlink.ru/api/shop/getShop`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(userData),
        })
            .then(response => {
                console.log(response);
                return response.text();
            })
            .then(text => {
                console.log(text);
                if (text) {
                    return JSON.parse(text);
                }
                return {};
            })
            .then(data => {
                console.log(data);
                if (data.success) {
                    setShopData(data);
                } else {
                    navigate(`/`);
                }
            })
            .catch(error => {
                console.error('Fetch error:', error);
                navigate(`/`);
            });
    }, [navigate]);

    useEffect(() => {
        const requestData = {
            uid: localStorage.getItem('uid'),
            email: localStorage.getItem('email'),
        };
        fetchShopData(requestData);
    }, [fetchShopData]);


    const fetchLoginData = (requestData) => {
        fetch(`https://gostlink.ru/api/profile`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(requestData),
        })
            .then((response) => response.text())
            .then((text) => {
                if (text) {
                    /** @type {{
                     success: boolean,
                     userInfo: {
                     id: number,
                     email: string,
                     expirationDate: string,
                     subscriptionIsActive: boolean,
                     discount: number,
                     nextTransactionDate: string,
                     amount: number,
                     currency: string,
                     subscriptionStatus: string
                     },
                     devices: any[],
                     availableDevices: number,
                     }} */
                    const data = JSON.parse(text);
                    if (data.success) {
                        setUserData(data.userInfo)
                        setUserSubscription(data.userInfo.subscriptionStatus)
                        setDeviceData(data.devices);
                        setAvailableDevices(data.availableDevices);
                        localStorage.setItem('expirationDate', data.userInfo.expirationDate);
                        localStorage.setItem('subscriptionIsActive', String(data.userInfo.subscriptionIsActive));
                        localStorage.setItem('subscriptionStatus', data.userInfo.subscriptionStatus);
                        console.log(data)
                    } else {
                        // Handle failure
                    }
                }
            })
            .catch((error) => {
                console.error('Fetch error:', error);
                // Handle error
            });
    };



    return (
        <div className="user-console-page">
            <div className="background-top-user-console background-main">
                <div className="gradient-top-user-console gradient-main"></div>
                {/*<div className="noise-top-user-console noise-main"/>*/}
            </div>
            <div className="background-bottom-user-console background-main">
                <div className="gradient-bottom-user-console gradient-main"></div>
                {/*<div className="noise-bottom-user-console noise-main"/>*/}
            </div>
            <div className="noise-main"/>

            <div className="user-console-content-main">
                <section className="account-info-main">
                    <UserInfoBlock/>
                </section>

                {(userSubscription === 'NOT_ACTIVE' || userSubscription === 'EXPIRED' || (userSubscription === 'CANCELED' && localStorage.getItem('subscriptionIsActive') === 'false')) &&
                    <section className="user-console-main">
                        <ShopBlock shopData={shopData} refreshShopData={fetchShopData}
                                   userSubscription={userSubscription}/>
                        <SupportBlock/>
                    </section>
                }
                {(userSubscription === 'CANCELED' && localStorage.getItem('subscriptionIsActive') === 'true') &&
                    <section className="user-console-main">
                        <ReferralBlock/>
                        <SubscriptionCancelledBlock shopData={shopData}/>
                        <DevicesBlock deviceData={deviceData} availableDevices={availableDevices}
                                      setDeviceData={setDeviceData} setAvailableDevices={setAvailableDevices}/>
                        <AppDownloadBlock/>
                        <SupportBlock/>
                    </section>
                }
                {userSubscription === 'ACTIVE' &&
                    <section className="user-console-main">
                        <ReferralBlock/>
                        <SubscriptionActiveBlock userData={userData}/>
                        <DevicesBlock deviceData={deviceData} availableDevices={availableDevices}
                                      setDeviceData={setDeviceData} setAvailableDevices={setAvailableDevices}/>
                        <AppDownloadBlock/>
                        <SupportBlock/>
                    </section>
                }
            </div>
            <section className="footer-section section-main" style={{paddingTop: '50px'}}>
                <hr/>
                <div className="content-footer">
                    <span>© 2021 — 2025&nbsp;&nbsp;&nbsp;&nbsp;ООО "Каннт"&nbsp;&nbsp;&nbsp;&nbsp;ИНН: 4011033196</span>
                    <button className="button-line-main button-footer"
                            onClick={() => {
                                navigate('/offer')
                            }}>
                        <span>
                            Публичная оферта
                        </span>
                    </button>
                </div>
            </section>
        </div>
    );
}

export default Profile_new;
